export default "__VITE_ASSET__0efd7dcd__"